import { ScenarioApi } from '../../src/lib/components/Planning/ScenarioApi';
import {
    AssignmentApi,
    type AssignmentResponseType,
} from '../../src/lib/components/Planning/AssignmentApi';
import { Assignment } from '../../src/lib/components/Planning/Assignment';
import { RoutePointsApi } from '../../src/lib/utilities/RoutePointsApi';
import { Api } from '@automapa/svelte-automapa-template';

export async function calculateRoute2(
    api: Api,
    scenario_id: number,
    assignmentId: number,
    expect: Function | null = null,
    expectedRoutePoints: number = 0,
    onAssignmentUpdate: Function | null = null
): Promise<string> {
    // calculate route
    let calcRouteResponse = await ScenarioApi.startRouting(api, scenario_id, [assignmentId]);
    if (expect) expect(calcRouteResponse).toMatchObject({ message: 'ok' });

    // get route id to get route
    let routeId: string | null = null;
    while (routeId === null) {
        let assignmentResponse3 = await AssignmentApi.getOne(api, assignmentId);
        if (onAssignmentUpdate) {
            onAssignmentUpdate(assignmentResponse3);
        }
        let assignment3 = new Assignment(assignmentResponse3);
        if (!assignment3.isRouteInCalculation()) {
            routeId = assignment3.getRouteId();
            if (routeId === null) {
                routeId = '';
            }
        } else {
            await new Promise(resolve => setTimeout(resolve, 1000));
        }
    }
    if (expect) expect(routeId).not.toBeNull();
    if (expect) expect(routeId).toMatch(/^route_\d+\.\w+\.\d+$/); // example: route_1713278284.661e8d4ca913d6.83936841

    // wait for route points (RoutePointsApi.getPoints will return empty array while calculation, we need to wait for not empty array)
    if (routeId) {
        let routePoints: any[] = [];
        while (routePoints.length === 0) {
            routePoints = await RoutePointsApi.getPoints(api, assignmentId);
            if (routePoints.length === 0) {
                await new Promise(resolve => setTimeout(resolve, 1000));
            }
        }

        if (expect) {
            if (expectedRoutePoints > 0) {
                expect(routePoints.length).toBe(expectedRoutePoints);
            }
            routePoints.forEach((rp, index) => {
                expect(rp.point_order).toBe(index); // point_order should be equal to index
            });
        }
    }

    return routeId;
}

export async function waitForEstimateRoute__NOTUSED(
    api: Api,
    assignmentId: number
): Promise<AssignmentResponseType> {
    let assignment = new Assignment(await AssignmentApi.getOne(api, assignmentId));
    while (!assignment.hasEstimation()) {
        let ass = await AssignmentApi.getOne(api, assignmentId);
        assignment.set(ass);
        await new Promise(resolve => setTimeout(resolve, 1000));
    }
    return assignment.get();
}
